var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "booking-form__container" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-md-12 text-center", attrs: { align: "center" } },
        [
          _c("p", [
            _c("a", { on: { click: _vm.openModal } }, [
              _vm._v("Unohtuiko salasana?"),
            ]),
          ]),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }